import React from 'react';
import { Alert } from 'react-bootstrap';
import './SyncNotification.css';

/**
 * Componente de notificação de sincronização de aulas
 *
 * Exibe um banner amigável informando que o material está desatualizado
 * em relação ao padrão, com um botão para sincronizar.
 *
 * @param {Object} props
 * @param {Object} props.verificacao - Dados da verificação de sincronização
 * @param {Function} props.onSincronizar - Callback ao clicar em sincronizar
 * @param {Function} props.onDismiss - Callback ao fechar a notificação
 * @param {boolean} props.show - Se a notificação deve ser exibida
 */
const SyncNotification = ({ verificacao, onSincronizar, onDismiss, show }) => {
  if (!show || !verificacao || !verificacao.precisa_sincronizar) {
    return null;
  }

  const { diferenca, tipo_sincronizacao, qtd_apresentacoes_faltantes } = verificacao;
  const aulasPalavra = Math.abs(diferenca) === 1 ? 'aula' : 'aulas';

  // Mensagem baseada no tipo de sincronização
  const getMensagem = () => {
    if (tipo_sincronizacao === 'adicionar') {
      return (
        <>
          <strong>Novidade!</strong> O material padrão foi atualizado e possui{' '}
          <strong>{Math.abs(diferenca)} {aulasPalavra}</strong> a mais que o seu material. {' '}
          Existem <strong>{qtd_apresentacoes_faltantes}</strong>{' '}
          {qtd_apresentacoes_faltantes === 1 ? 'apresentação nova' : 'novas apresentações'}{' '}
          para você alinhar com a agenda da Harve!
        </>
      );
    } else {
      return (
        <>
          <strong>Atenção!</strong> O material padrão foi otimizado e possui{' '}
          <strong>{Math.abs(diferenca)} {aulasPalavra}</strong> a menos. {' '}
          Ajuste seu material para ficar alinhado com a agenda da Harve!
        </>
      );
    }
  };

  return (
    <Alert
      variant={tipo_sincronizacao === 'adicionar' ? 'info' : 'warning'}
      dismissible
      onClose={onDismiss}
      className="sync-notification"
    >
      <div className="sync-notification-content">
        <div className="sync-notification-message">
          {getMensagem()}
        </div>
        <button
          className="btn btn-sm btn-primary sync-notification-button"
          onClick={onSincronizar}
        >
          Corrigir
        </button>
      </div>
    </Alert>
  );
};

export default SyncNotification;
